import { Reveal, Frame } from "../motion";
import { Eyebrow } from "../ui-bits";

const PILLARS = [
  { t: "Strategia", d: "Obiettivi chiari, un tono di voce riconoscibile, un piano che si può seguire davvero." },
  { t: "Produzione", d: "Foto, video e Reel realizzati in studio e sul campo, con attenzione per ogni dettaglio." },
  { t: "Gestione", d: "Pubblicazione, community, campagne e lettura dei dati. Tutti i giorni, non solo al lancio." },
];

export const Intro = () => (
  <section className="px-5 py-24 sm:px-10 md:py-36 lg:px-16" data-testid="home-intro">
    <div className="grid grid-cols-12 gap-y-14 lg:gap-x-10">
      <div className="col-span-12 lg:col-span-3">
        <Reveal><Eyebrow n="01">Lo studio</Eyebrow></Reveal>
      </div>
      <div className="col-span-12 lg:col-span-9">
        <Reveal>
          <p className="font-serif text-[1.7rem] leading-[1.3] sm:text-4xl lg:text-[2.9rem] lg:leading-[1.25]">
            Strategia, produzione e gestione operativa nello stesso studio. Chi scrive il piano editoriale lavora accanto a chi gira il Reel e a chi legge i dati la settimana dopo.{" "}
            <span className="text-ink/45">Così un'idea non si perde tra un passaggio e l'altro.</span>
          </p>
        </Reveal>
      </div>
    </div>
    <div className="mt-20 grid grid-cols-12 gap-y-12 md:mt-28 lg:gap-x-10">
      <Frame src="/img/set-produzione.webp" alt="Due operatrici, viste di spalle, riprendono con smartphone su stabilizzatore e fotocamera una professionista sul set" className="col-span-12 aspect-[16/10] md:col-span-7" testid="intro-image" />
      <div className="col-span-12 flex flex-col justify-end gap-10 md:col-span-4 md:col-start-9">
        {PILLARS.map((p, i) => (
          <Reveal key={p.t} delay={i * 0.1} className="border-t border-ink/15 pt-6">
            <h3 className="text-2xl">{p.t}</h3>
            <p className="mt-3 text-sm leading-relaxed text-ink/75 md:text-base">{p.d}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
